import { render, staticRenderFns } from "./EmailDelivery.vue?vue&type=template&id=233f0cc3"
import script from "./EmailDelivery.vue?vue&type=script&lang=js"
export * from "./EmailDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports